define.alias("shared/components/shared/social/refresh-profile-list", "settings/components/shared/social/refresh-profile-list");